import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../hooks/useAuth";

// Provider-only routes (the /patients/* family — provider chart / patient
// list / clinical profile editor). Patients have a per-patient org and
// their own plan; if a patient URL-manips into one of these provider
// surfaces the backend already refuses data, but the page still mounts and
// can leak UX hints. Defense in depth: redirect patients to the peptide
// dashboard before the provider component renders.
//
// Lives in utils/ rather than inline in Routes.js so the unit test can
// import it without dragging in every provider page (and their transitive
// `heic-to` parsing pain).
export function withProviderOnlyGuard(Component) {
  return function ProviderOnlyGuard(props) {
    const { auth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      // Wait for session to hydrate. Auth payload arrives in stages — a
      // partial state would otherwise wrongly redirect during boot.
      if (!auth?.session) return;
      if (auth?.session?.currentOrganizationPlan === "order-patient") {
        navigate("/peptides", { replace: true });
      }
    }, [auth?.session, navigate]);

    return <Component {...props} />;
  };
}
